import ActionType, { verifyInvitationErrorStatus } from './types';
import { InvitationAction } from './actions';

type VerifyInvitationStatus =
  | 'not_set'
  | 'checking'
  | 'verified'
  | verifyInvitationErrorStatus;

export interface InvitationState {
  status: VerifyInvitationStatus;
}

export const initialState: () => InvitationState = () => {
  return {
    status: 'not_set'
  };
};

const reducer = (
  state: InvitationState = initialState(),
  action: InvitationAction
): InvitationState => {
  switch (action.type) {
    case ActionType.verifyInvitation: {
      const newState = { ...state };
      newState.status = 'checking';
      return newState;
    }
    case ActionType.successToVerifyInvitation: {
      const newState = { ...state };
      newState.status = 'verified';
      return newState;
    }
    case ActionType.failedToVerifyInvitation: {
      const newState = { ...state };
      newState.status = action.payload as verifyInvitationErrorStatus;
      return newState;
    }
    default:
      return state;
  }
};

export default reducer;
